import { render } from "./cp_major_select.vue?vue&type=template&id=0d6a51de&scoped=true"
import script from "./cp_major_select.vue?vue&type=script&lang=js"
export * from "./cp_major_select.vue?vue&type=script&lang=js"

import "./cp_major_select.vue?vue&type=style&index=0&id=0d6a51de&scoped=scoped&lang=css"

import exportComponent from "E:\\Work\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6a51de"]])

export default __exports__